import { useEffect } from "react";

/**
 * View 화면 높이 변경
 * useHandleResize를 useVhResize로 변경
 */
function useVhResize(): void {
  useEffect(() => {
    const handleVhResize = (): void => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };

    window.addEventListener("resize", handleVhResize);

    return () => {
      window.removeEventListener("resize", handleVhResize);
    };
  }, []);
}

export default useVhResize;
